// src/context/MyContext.js
import React, { createContext, Component } from "react";

// Create Context
export const MyContext = createContext();

// Create Provider Component
export class MyProvider extends Component {
    state = {
        mainMenuMessage: "Main Menu",
    };

    // Function to update the mainMenuMessage
    updateMainMenuMessage = (newMessage) => {
        this.setState({ mainMenuMessage: newMessage });
    };

    render() {
        return (
            <MyContext.Provider
                value={{
                    mainMenuMessage: this.state.mainMenuMessage,
                    updateMainMenuMessage: this.updateMainMenuMessage, // Pass updater function
                    cometdInstance: this.props.cometdInstance
                }}
            >
                {this.props.children}
            </MyContext.Provider>
        );
    }
}
